import { useEffect, useState } from "react";
import { Loader2, Search, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { B } from "./common";
import { Avatar } from "./PostCard";

export default function ShareDialog({ post, onClose }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    if (!post) return;
    const t = setTimeout(() => api.get(`${B}/utenti`, { params: { q } }).then((r) => setRows(r.data)).catch(() => setRows([])), 250);
    return () => clearTimeout(t);
  }, [q, post]);
  const send = async (u) => {
    setBusy(u.uid);
    try {
      const { data } = await api.post(`${B}/dm/start`, { uid: u.uid });
      const label = post.titolo || (post.testo || "").slice(0, 60) || "post";
      await api.post(`${B}/dm/${data.id}/messages`, { testo: `Ti ho condiviso un post: «${label}»\n${window.location.origin}/vesta/bacheca?post=${post.id}` });
      toast.success(`Inviato a ${u.staff ? u.name : u.partner_name || u.name}`);
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Invio non riuscito"); }
    setBusy(null);
  };
  return (
    <Dialog open={!!post} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md border-[#2A303C] bg-[#16191E] text-white" data-testid="bacheca-share-dialog">
        <DialogHeader><DialogTitle className="font-heading text-lg">Invia in privato</DialogTitle><DialogDescription className="text-[#9CA3AF]">Scegli un installatore o il team Torri.</DialogDescription></DialogHeader>
        <div className="flex items-center gap-2 rounded-full border border-[#2A303C] bg-[#121418] px-3">
          <Search className="h-4 w-4 text-[#6B7280]" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca azienda o nome…" className="h-10 w-full bg-transparent text-sm outline-none" data-testid="bacheca-share-search" />
        </div>
        <div className="max-h-80 space-y-1 overflow-y-auto">
          {!rows ? <Loader2 className="h-5 w-5 animate-spin text-[#C17F59]" /> : rows.map((u) => (
            <div key={u.uid} className="flex items-center gap-3 rounded-xl px-2 py-2 hover:bg-[#1F242D]" data-testid={`bacheca-share-user-${u.uid}`}>
              <Avatar a={u} logo={u.logo} foto={u.foto} size={36} />
              <div className="min-w-0 flex-1"><div className="truncate text-sm font-semibold">{u.staff ? u.name : u.partner_name || u.name}</div><div className="truncate text-xs text-[#9CA3AF]">{u.staff ? "Torri Solar" : u.name}</div></div>
              <button type="button" onClick={() => send(u)} disabled={!!busy} className="flex items-center gap-1 rounded-full bg-[#C17F59] px-3 py-1.5 text-xs font-bold text-white disabled:opacity-50" data-testid={`bacheca-share-send-${u.uid}`}>
                {busy === u.uid ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}Invia
              </button>
            </div>
          ))}
          {rows && rows.length === 0 && <p className="py-4 text-center text-sm text-[#6B7280]">Nessun risultato.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
